import React from "react"
import { blog } from "../../../dummydata"
import "./footer.css"

const Footer = () => {
  return (
    <>
      {/* <section className='newletter'>
        <div className='container flexSB'>
          <div className='left row'>
            <h1>Newsletter - Stay tune and get the latest update</h1>
            <span>Far far away, behind the word mountains</span>
          </div>
          <div className='right row'>
            <input type='text' placeholder='Enter email address' />
            <i className='fa fa-paper-plane'></i>
          </div>
        </div>
      </section> */}
      <footer>
        <div className='container padding'>
          <div className='box logo'>
            <h1>HLC Tree Tech</h1>
            {/* <span>ONLINE EDUCATION & LEARNING</span> */}
            <p>Learn Today. Build Your Tomorrow. With Our Support.</p>
            <div className='socials'>
              <a href='https://www.facebook.com/profile.php?id=61584417224002' target='_blank' rel='noopener noreferrer' aria-label='Facebook'>
                <i className='fab fa-facebook-f icon'></i>
              </a>
              <a href='https://www.youtube.com/@hlctechsolutions?si=ESsaKrf7-TpW9pfE' target='_blank' rel='noopener noreferrer' aria-label='Twitter'>
                <i className='fab fa-youtube icon'></i>
              </a>
              <a href='https://www.instagram.com/hlc_tree_technologies?idsh=MWg5eWx0MXhhZ2Fodg==' target='_blank' rel='noopener noreferrer' aria-label='Instagram'>
                <i className='fab fa-instagram icon'></i>
              </a>
            </div>
          </div>
          {/* <div className='box link'>
            <h3>Explore</h3>
            <ul>
              <li>About Us</li>
              <li>Services</li>
              <li>Courses</li>
              <li>Blog</li>
              <li>Contact us</li>
            </ul>
          </div> */}
          {/* <div className='box link'>
            <h3>Quick Links</h3>
            <ul>
              <li>Contact Us</li>
              <li>Pricing</li>
              <li>Terms & Conditions</li>
              <li>Privacy</li>
              <li>Feedbacks</li>
            </ul>
          </div> */}
          <div className='box'>
            <h3>Recent Post</h3>
            {blog.slice(0, 3).map((val) => (
              <div className='items flexSB'>
                <div className='img'>
                  <img src={val.cover} alt='' />
                </div>
                <div className='text'>
                  <div className='meta'>
                    <span>
                      <i className='fa fa-calendar-alt'></i>
                      <label htmlFor=''>{val.date}</label>
                    </span>
                    <span>
                      <i className='fa fa-user'></i>
                      <label htmlFor=''>{val.type}</label>
                    </span>
                  </div>
                  <h4>{val.title.slice(0, 40)}...</h4>
                </div>
              </div>
            ))}
          </div>
          <div className='box last'>
            <h3>Have a Questions?</h3>
            <ul>
              <li>
                <i className='fa fa-map'></i>
                  1st Main Road, Biriyani Zone Back Side, Outer Ring Rd, Vivekanandda Layout, Chandra Layout, Marathahalli, Bengaluru, Karnataka 560037
              </li>
              <li>
                <i className='fa fa-phone-alt'></i>
                +91 9606746630
              </li>
              <li>
                <i className='fa fa-paper-plane'></i>
                info@hlctreetechnologies.com
              </li>
            </ul>
          </div>
        </div>
      </footer>
      <div className='legal'>
        <p>
          Copyright ©2025 All rights reserved | This template is made with <i className='fa fa-heart'></i> by HLC Technologies 
        </p>
      </div>
    </>
  )
}

export default Footer
